let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hvMMD")).then(() => parcelRequire('hV7Xw'));